<div class="radar-button-group text-center mb-3">
  <button type="button" class="btn btn-outline-primary me-2" (click)="selectRadarType('PPI')">PPI</button>
  <button type="button" class="btn btn-outline-primary me-2" (click)="selectRadarType('MAKS')">MAKS</button>
  <button type="button" class="btn btn-outline-primary me-2" (click)="selectRadarType('VIL')">VIL</button>
  <button type="button" class="btn btn-outline-primary" (click)="selectRadarType('RUZGAR')">RÜZGAR</button>
</div>
<div class="radar-image-container">
  <img [src]="currentDisplayImageUrl" alt="Bölgesel Radar Görseli" class="img-fluid radar-image-container">
</div>
